import { render } from "./ManagerCustomersPage.vue?vue&type=template&id=271278ca&scoped=true"
import script from "./ManagerCustomersPage.vue?vue&type=script&lang=js"
export * from "./ManagerCustomersPage.vue?vue&type=script&lang=js"

import "./ManagerCustomersPage.vue?vue&type=style&index=0&id=271278ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271278ca"]])

export default __exports__